import React from 'react';
import { EmailTemplate } from '../types';

interface WelcomeEmailData {
  name: string;
  email: string;
  confirmationUrl?: string;
}

export const WelcomeEmailTemplate: EmailTemplate<WelcomeEmailData> = {
  id: 'welcome',
  name: 'Welcome Email',
  subject: ({ name }) => `Welcome to our app, ${name}!`,
  preview: 'Welcome to our community',
  body: {
    html: (data) => `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Welcome</title>
          <style>
            body {
              font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
              line-height: 1.6;
              color: #333;
              max-width: 600px;
              margin: 0 auto;
              padding: 20px;
            }
            .header {
              background-color: #007bff;
              color: white;
              padding: 30px;
              text-align: center;
              border-radius: 8px 8px 0 0;
            }
            .content {
              background-color: #f8f9fa;
              padding: 30px;
              border-radius: 0 0 8px 8px;
            }
            .button {
              display: inline-block;
              padding: 12px 24px;
              background-color: #007bff;
              color: white;
              text-decoration: none;
              border-radius: 5px;
              margin-top: 20px;
            }
            .footer {
              text-align: center;
              margin-top: 30px;
              color: #6c757d;
              font-size: 14px;
            }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>Welcome to Our App!</h1>
          </div>
          <div class="content">
            <h2>Hi ${data.name},</h2>
            <p>We're excited to have you join our community! Your account has been successfully created.</p>
            <p>Here are your account details:</p>
            <ul>
              <li><strong>Email:</strong> ${data.email}</li>
            </ul>
            ${data.confirmationUrl ? `
              <p>Please confirm your email address by clicking the button below:</p>
              <a href="${data.confirmationUrl}" class="button">Confirm Email</a>
            ` : ''}
            <p>If you have any questions, feel free to reach out to our support team.</p>
            <p>Best regards,<br>The Team</p>
          </div>
          <div class="footer">
            <p>© 2024 Your Company. All rights reserved.</p>
          </div>
        </body>
      </html>
    `,
    text: (data) => `
Welcome to Our App!

Hi ${data.name},

We're excited to have you join our community! Your account has been successfully created.

Here are your account details:
- Email: ${data.email}

${data.confirmationUrl ? `Please confirm your email address by visiting: ${data.confirmationUrl}` : ''}

If you have any questions, feel free to reach out to our support team.

Best regards,
The Team

© 2024 Your Company. All rights reserved.
    `.trim(),
  },
};

export function WelcomeEmail(props: WelcomeEmailData) {
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: 600, margin: '0 auto' }}>
      <div style={{ backgroundColor: '#007bff', color: 'white', padding: 30, textAlign: 'center' }}>
        <h1>Welcome to Our App!</h1>
      </div>
      <div style={{ backgroundColor: '#f8f9fa', padding: 30 }}>
        <h2>Hi {props.name},</h2>
        <p>We're excited to have you join our community! Your account has been successfully created.</p>
        <p>Here are your account details:</p>
        <ul>
          <li><strong>Email:</strong> {props.email}</li>
        </ul>
        {props.confirmationUrl && (
          <>
            <p>Please confirm your email address by clicking the button below:</p>
            <a 
              href={props.confirmationUrl} 
              style={{
                display: 'inline-block',
                padding: '12px 24px',
                backgroundColor: '#007bff',
                color: 'white',
                textDecoration: 'none',
                borderRadius: 5,
                marginTop: 20,
              }}
            >
              Confirm Email
            </a>
          </>
        )}
        <p>If you have any questions, feel free to reach out to our support team.</p>
        <p>Best regards,<br />The Team</p>
      </div>
      <div style={{ textAlign: 'center', marginTop: 30, color: '#6c757d', fontSize: 14 }}>
        <p>© 2024 Your Company. All rights reserved.</p>
      </div>
    </div>
  );
}